interface YouTubeShortEmbedProps {
  videoId: string; // contoh: "abc123XYZ" dari link https://www.youtube.com/shorts/abc123XYZ
}

export function GlobalYouTubeShortEmbed({ videoId }: YouTubeShortEmbedProps) {
  return (
    <div className="w-full flex justify-center">
      <iframe
        width="100%"
        height="600"
        src={`https://www.youtube.com/embed/${videoId}?autoplay=0&mute=0&modestbranding=1&rel=0`}
        title="YouTube Shorts video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="rounded-xl shadow-lg max-w-[400px]"
      ></iframe>
    </div>
  );
}
